export default __webpack_public_path__ + "static/media/comment.a2c3e1f7.svg";